import { render } from "./CreateBuildingForm.vue?vue&type=template&id=7c7c77d8"
import script from "./CreateBuildingForm.vue?vue&type=script&lang=js"
export * from "./CreateBuildingForm.vue?vue&type=script&lang=js"

import "./CreateBuildingForm.vue?vue&type=style&index=0&id=7c7c77d8&lang=css"
script.render = render

export default script